'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Logo = exports.Image = exports.ImageContainer = exports.Position = exports.Author = exports.Message = exports.Wrapper = undefined;

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _H = require('UIComponents/elements/headings/H3');

var _H2 = _interopRequireDefault(_H);

var _H3 = require('UIComponents/elements/headings/H6');

var _H4 = _interopRequireDefault(_H3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Wrapper = exports.Wrapper = _styledComponents2.default.div.withConfig({
  displayName: 'TestimonialSidebarstyles__Wrapper'
})(['flex:1;display:flex;flex-flow:column nowrap;max-width:350px;margin:0 auto;align-items:center;']);

var Message = exports.Message = (0, _styledComponents2.default)(_H2.default).withConfig({
  displayName: 'TestimonialSidebarstyles__Message'
})(['font-size:19px;line-height:33px;font-weight:300;text-align:center;margin-bottom:40px;margin-top:-40px;']);

var Author = exports.Author = (0, _styledComponents2.default)(_H4.default).withConfig({
  displayName: 'TestimonialSidebarstyles__Author'
})(['margin-bottom:0;line-height:19px;text-align:center;']);

var Position = exports.Position = _styledComponents2.default.p.withConfig({
  displayName: 'TestimonialSidebarstyles__Position'
})(['line-height:22px;margin-bottom:0;text-align:center;']);

var ImageContainer = exports.ImageContainer = _styledComponents2.default.div.withConfig({
  displayName: 'TestimonialSidebarstyles__ImageContainer'
})(['display:flex;justify-content:center;align-items:center;']);

var Image = exports.Image = _styledComponents2.default.img.withConfig({
  displayName: 'TestimonialSidebarstyles__Image'
})(['max-width:100%;@media (min-width:1024px){max-width:350px;}']);

var Logo = exports.Logo = _styledComponents2.default.img.withConfig({
  displayName: 'TestimonialSidebarstyles__Logo'
})(['max-width:90px;margin-top:20px;']);